import { DocumentStaticActionType } from '@views/documents/elements/DocumentStaticActions'

import { FileListItem } from '../types/fileListItem'

export const hasContextMenuActions = (item: FileListItem, restrictedActions?: DocumentStaticActionType[]): boolean => {
  const { isReadOnly, type } = item

  if (restrictedActions) {
    return restrictedActions.length > 0
  }

  if (isReadOnly) {
    return type === 'document'
  }

  return true
}
